import { injectable } from 'inversify';
import * as yup from 'yup';
import { RoleInput } from '../generated/types';
import { BaseRolesService } from '../services/baseRolesService';
import { TranslationService } from '../services/translationService';
import { InputService } from './inputService';

@injectable()
export class RoleInputService extends InputService {
    constructor(
        private baseRolesService: BaseRolesService,
        translationService: TranslationService
    ) {
        super(translationService);
    }

    default(): { role: RoleInput } {
        return {
            role: {
                positionPermissions: this.baseRolesService.get().PositionReader.positionPermissions,
                name: '',
                description: ''
            }
        };
    }

    schema() {
        return yup
            .object()
            .shape({
                role: yup
                    .object()
                    .shape({
                        positionPermissions: this.positionPermissions().required(
                            this.t('le_format_des_p_68818')
                        ),
                        name: yup.string().required(this.t('le_nom_est_requ_61536')),
                        description: yup.string().required(this.t('la_description_46559'))
                    })
                    .required()
            })
            .required();
    }

    positionPermissions() {
        return yup
            .string()
            .matches(
                new RegExp(
                    `^[01]{${this.baseRolesService.get().PositionReader.positionPermissions.length}}$`
                ),
                this.t('le_format_des_p_68818')
            );
    }
}
